import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { deUpdateMedicationMutation } from "@/modules/patients/detail/medication/de/services/__generated__/deUpdateMedicationMutation.graphql"

const mutation = graphql`
  mutation deUpdateMedicationMutation($input: De_updateMedicationInput!, $connections: [ID!]!) {
    de_updateMedication(input: $input) {
      de_Medication @appendNode(connections: $connections, edgeTypeName: "De_medicationsEdge") {
        id
        ...deMedicationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeUpdateMedicationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<deUpdateMedicationMutation>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<deUpdateMedicationMutation>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeUpdateMedicationMutation }
